import React from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { makeStyles, Typography } from '@material-ui/core';
import WelcomeImage from 'assets/onboarding/reminderscreen.jpg';
import PersonalInfoImage from 'assets/onboarding/personalinfo.jpg';
import HighschoolImage from 'assets/onboarding/reminderscreen.jpg';
import AcademicImage from 'assets/onboarding/academicinfo.jpg';
import InterestImage from 'assets/onboarding/personalinfo.jpg';
import CollegeQuestionImage from 'assets/onboarding/personalityinfo.jpg';
import CollegeExpImage from 'assets/onboarding/reminderscreen.jpg';
import AppStatusImage from 'assets/onboarding/reminderscreen.jpg';
import WeadmitLogo from 'assets/logo-white-bg-none.svg';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';
import bannerImage from 'assets/login/banner.jpg';
import logoImg from 'assets/logo-black.svg';

const IMAGES = [
  WelcomeImage,
  PersonalInfoImage,
  HighschoolImage,
  AcademicImage,
  InterestImage,
  CollegeQuestionImage,
  CollegeExpImage,
  AppStatusImage,
];

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: 'relative',
    justifyContent: 'flex-start',
    backgroundImage: (props) => `url(${props.bg})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    color: 'white',
  },
  textContainer: {
    'position': 'relative',
    'overflow': 'auto',
    'height': '100vh',
    'display': 'flex',
    'flex': 1,
    'flexDirection': 'column',
    'backgroundColor': theme.palette.background.paper,
    '& .MuiTypography-h5': {
      marginBottom: theme.spacing(5),
      ...theme.typography.h3,
    },
  },
  logo: {
    position: 'absolute',
    top: theme.spacing(4),
    left: theme.spacing(4),
  },
  back: {
    position: 'absolute',
  },
}));

const Layout = ({ step, children, showBack, stepLabel }) => {
  const classes = useStyles({ bg: bannerImage });
  const history = useHistory();

  return (
    <Box display="flex">
      <Box className={classes.imageContainer} width={{ md: '40%' }} display={{ xs: 'none', md: 'flex'}}>
        <img src={logoImg} alt="logo" className={classes.logo} />
        <Box
          padding={4}
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          style={{ height: '100vh' }}
          justifyContent="flex-end"
        >
          <Typography
            component="em"
            gutterBottom
            variant="subtitle1"
            color="inherit"
            style={{ fontSize: 19 }}
          >
            
          </Typography>
          <Typography
            component="em"
            style={{ textAlign: 'right', fontSize: 19 }}
            variant="subtitle1"
            color="inherit"
          >
          
          </Typography>
        </Box>
      </Box>
      <Box className={classes.textContainer} padding={3}>
        {showBack && (
          <IconButton onClick={() => history.goBack()} className={classes.back}>
            <ChevronLeftIcon />
          </IconButton>
        )}
        {stepLabel && (
          <Box marginBottom={4} textAlign="center" marginTop={1.6}>
            <Typography variant="caption">{stepLabel}</Typography>
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
